export const GUAC_CLIENT_STATE_DISCONNECTING = 4;
export const GUAC_CLIENT_STATE_DISCONNECTED = 5;
